import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Anchor } from "@/components/Anchor";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex, Header } from "@/eworkitComponents";
import { RouteButton } from "@/infrastructure/Route";
import { router } from "@/views/router";

interface Props {
  jobRequestId: number;
}

export const JobRequestPublicCreateAccountSection: FC<Props> = memo(({ jobRequestId }) => {
  const { t } = useTranslation("session");
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);
  const baseClass = "job-request-detail";

  return (
    <Flex
      direction="column"
      align="center"
      innerPadding={isSmallScreen ? "xs" : "md"}
      className={`${baseClass}__public_section`}>
      <Header size={isSmallScreen ? "sm" : "md"} weight="bold">
        {t("JOB_REQUESTS.DETAIL.WANT_TO_KNOW_MORE")}
      </Header>
      <Text size={isSmallScreen ? "sm" : "md"} color="black">
        {t("JOB_REQUESTS.DETAIL.CREATE_AN_ACCOUNT_TO_GET_ACCESS")}
      </Text>
      <RouteButton
        path={router.get("auth", {}, { tab: "registerForm", jobRequestId }).path}
        variant="secondary"
        size={isSmallScreen ? "md" : "lg"}
        className="signup__btn">
        {t("JOB_REQUESTS.DETAIL.CREATE_ACCOUNT")}
      </RouteButton>
      <Flex direction="row" innerMargin="xs" innerPadding="xs" align="center">
        <Text size={isSmallScreen ? "sm" : "md"} color="black">
          {t("JOB_REQUESTS.DETAIL.ALREADY_HAVE_AN_ACCOUNT")}
        </Text>
        <Anchor href={router.get("auth", {}, { tab: "login", jobRequestId }).path} size={isSmallScreen ? "sm" : "md"}>
          {t("JOB_REQUESTS.DETAIL.LOGIN_HERE")}
        </Anchor>
      </Flex>
    </Flex>
  );
});
